module.exports = __webpack_public_path__ + "img/cw.68930399.svg";